import { useQuery, useQueryClient, UseQueryResult } from 'react-query';
import { UserProfileResponse } from '~client/model/user-profile-response';
import { useSuccessReaction } from '~common/hook/use-reaction';
import { useApiClient } from '~web/client/api-client-provider';
import { createPaymentMethod } from '~web/interactor/payment/create-payment-method';
import { deletePaymentMethod } from '~web/interactor/payment/delete-payment-method';
import { updatePaymentMethod } from '~web/interactor/payment/update-payment-means';
import { changePassword } from '~web/interactor/user-login/perform-change-password';
import { login } from '~web/interactor/user-login/perform-login';
import { stores } from '~web/store';
import { UserProfileStore } from '~web/store/user-profile/user-profile-store';
import { useAuthentication } from '~web/view/hooks/use-authentication';
import { useStore } from '~web/view/hooks/use-store';

export const PROFILE_QUERY_KEY = 'userProfile';

export const useProfileQuery = (): UseQueryResult<UserProfileResponse, Error> => {
  const apiClient = useApiClient();
  const authenticated = useAuthentication();
  const userProfileStore = useStore<UserProfileStore>(stores.userProfileStore);
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: (): Promise<UserProfileResponse> => apiClient.userProfileController.getProfile(),
    onSuccess: (data) => userProfileStore.setResult(data),
    enabled: authenticated,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

//fetch the profile and initialize the store & side-effects.
export const useProfileInitialize = (): void => {
  const query = useProfileQuery();
  const queryClient = useQueryClient();

  //TODO(Asif): fix after refactoring the tasks below
  useSuccessReaction(login, (result): void => {
    const { authToken, needsEmailVerification, ...profile } = result;
    queryClient.setQueryData(PROFILE_QUERY_KEY, profile);
  });
  useSuccessReaction(changePassword, (result): void => {
    const { authToken, needsEmailVerification, ...profile } = result;
    queryClient.setQueryData(PROFILE_QUERY_KEY, profile);
  });
  useSuccessReaction(createPaymentMethod, (): void => {
    query.refetch();
  });
  useSuccessReaction(updatePaymentMethod, (): void => {
    query.refetch();
  });
  useSuccessReaction(deletePaymentMethod, (): void => {
    query.refetch();
  });
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/interactor/user-profile/perform-get-profile.ts